import { setPathingAppState, setAppError } from "../../actions/App/dispatchers";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";
import { fetch_live_story_page } from "../../actions/LiveStory/dispatchers";
import {
    getIsNinePreview,
    metaNinePreviewReplacer,
} from "../../utils/page/library";

export const fetchLiveStoryPageData =
    (path, params, queryParams) => (dispatch) => {
        const { contentId } = params;
        const timestamp = queryParams?.ts ?? null;
        const isPreview = getIsNinePreview(path);
        const newPath = isPreview ? metaNinePreviewReplacer(path) : path;

        const fetch_live_story_page_data = fetch_live_story_page(
            contentId,
            isPreview,
            timestamp
        );

        return Promise.all([
            dispatch(reset_app_state(newPath, contentId)),
            dispatch(fetch_live_story_page_data),
        ])
            .then(() => {
                dispatch(setPathingAppState(newPath, false, contentId));
            })
            .catch((error) => {
                dispatch(setAppError(newPath, error.code));
            });
    };
